<template>
<div class="">
<Banner />
<!--START: display for desktop -->
<div class="content" style="padding-top:6px;padding-bottom:8px;">
      <!--START: display for mobile -->
      <div class="content ct-mobile m-b-lg hidden-lg">
        <div class="row" >
            <div class="col-xs-6 text-center type-zoomin1">
              <div class="panel-body type-sh">
                <a href="/quick_quotation">
                  <div class="service-box mt-5 mx-auto">
                    <div style="margin-top:22px;">
                      <i class="fas fa-heartbeat" style="font-size:40px;"></i>
                      <h5 class="mb-3" style="margin-top:10px;">เช็กเบี้ยประกันภัย</h5>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div class="col-xs-6 text-center type-zoomin1 ">
              <div class="panel-body type-sh">
                <router-link to="/quotation">
                  <div class="service-box mt-5 mx-auto">
                    <div style="margin-top:22px;">
                      <i class="fas fa-clipboard" style="font-size:40px;"></i>
                      <h5 class="mb-3" style="margin-top:10px;">ใบเสนอราคา</h5>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>

            <div class="col-xs-6 text-center type-zoomin1">
              <div class="panel-body type-sh">
                <a href="/draft">
                  <div class="service-box mt-5 mx-auto">
                    <div style="margin-top:22px;">
                      <i class="far fa-edit" style="font-size:40px;"></i>
                      <h5 class="mb-3" style="margin-top:10px;">จัดการบันทึกฉบับร่าง</h5>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div class="col-xs-6 text-center type-zoomin1">
              <div class="panel-body type-sh">
                <a href="/report_daily">
                  <div class="service-box mt-5 mx-auto">
                    <div style="margin-top:22px;">
                      <i class="fa fa-line-chart" style="font-size:40px;"></i>
                      <h5 class="mb-3" style="margin-top:10px;">รายงานยอดขายของพนักงาน</h5>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div class="col-xs-6 text-center type-zoomin1"
              v-if="scoped== 'all'
              || scoped== 'sale_admin'
              || scoped== 'manager_branch' "
            >
              <div class="panel-body type-sh">
                <a href="/report_branch">
                  <div class="service-box mt-5 mx-auto">
                    <div style="margin-top:22px;">
                      <i class="fas fa-hand-holding-usd" style="font-size:40px;"></i>
                      <h5 class="mb-3" style="margin-top:10px;">รายงานยอดขายประจำสาขา</h5>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div class="col-xs-6 text-center type-zoomin1"
              v-if="scoped== 'all'
              || scoped== 'sale_admin'
              || scoped== 'manager_district' "
            >
              <div class="panel-body type-sh">
                <a href="/report_district">
                  <div class="service-box i-box-other mt-5 mx-auto">
                    <div style="margin-top:22px;">
                      <i class="fas fa-users" style="font-size:40px;"></i>
                      <h5 class="mb-3" style="margin-top:10px;">รายงานยอดขายประจำเขต</h5>
                    </div>
                  </div>
                </a>
              </div>
            </div>
        </div>
      </div>
      <!--END: display for mobile -->

      <!--START: display for desktop -->
      <div class="content ct-desktop type-home hidden-xs hidden-md" >
        <!-- for tvi -->
        <div class="row row-tyoe-home" v-if="scoped == 'all'">

          <div class="col-md-2 text-center type-zoomin1">
            <a href="/quick_quotation">
              <div class="service-box mt-5 mx-auto">
                <div style="margin-top:22px;">
                  <i class="fas fa-heartbeat" style="font-size:40px;"></i>
                  <h5 class="mb-3" style="margin-top:10px;">เช็กเบี้ยประกันภัย</h5>
                </div>
              </div>
            </a>
          </div>

          <div class="col-md-2 text-center type-zoomin1">
            <router-link to="/quotation">
              <div class="service-box mt-5 mx-auto">
                <div style="margin-top:22px;">
                  <i class="fas fa-clipboard" style="font-size:40px;"></i>
                  <h5 class="mb-3" style="margin-top:10px;">ใบเสนอราคา</h5>
                </div>
              </div>
            </router-link>
          </div>

          <div class="col-md-2 text-center type-zoomin2">
            <a href="/draft">
              <div class="service-box mt-5 mx-auto">
                <div style="margin-top:22px;">
                  <i class="far fa-edit" style="font-size:40px;"></i>
                  <h5 class="mb-3" style="margin-top:10px;">จัดการบันทึกฉบับร่าง</h5>
                </div>
              </div>
            </a>
          </div>

          <div class="col-md-2 text-center type-zoomin4">
            <a href="/report_daily">
              <div class="service-box mt-5 mx-auto">
                <div style="margin-top:22px;">
                  <i class="fa fa-line-chart" style="font-size:40px;"></i>
                  <h5 class="mb-3" style="margin-top:10px;">รายงานยอดขายของพนักงาน</h5>
                </div>
              </div>
            </a>
          </div>

          <div class="col-md-2 text-center type-zoomin5">
            <a href="/report_branch">
              <div class="service-box mt-5 mx-auto">
                <div style="margin-top:22px;">
                  <i class="fas fa-hand-holding-usd" style="font-size:40px;"></i>
                  <h5 class="mb-3" style="margin-top:10px;">รายงานยอดขายประจำสาขา</h5>
                </div>
              </div>
            </a>
          </div>

          <div class="col-md-2 text-center type-zoomin6">
            <a href="/report_district">
              <div class="service-box i-box-other mt-5 mx-auto">
                <div style="margin-top:22px;">
                  <i class="fas fa-users" style="font-size:40px;"></i>
                  <h5 class="mb-3" style="margin-top:10px;">รายงานยอดขายประจำเขต</h5>
                </div>
              </div>
            </a>
          </div>
        </div>

        <!-- for sale -->
        <div class="row row-tyoe-home" v-else-if="scoped == 'sale'">

          <div class="col-md-3 text-center type-zoomin1">
            <a href="/quick_quotation">
              <div class="service-box mt-5 mx-auto">
                <div style="margin-top:22px;">
                  <i class="fas fa-heartbeat" style="font-size:40px;"></i>
                  <h5 class="mb-3" style="margin-top:10px;">เช็กเบี้ยประกันภัย</h5>
                </div>
              </div>
            </a>
          </div>

          <div class="col-md-3 text-center type-zoomin1">
            <router-link to="/quotation">
              <div class="service-box mt-5 mx-auto">
                <div style="margin-top:22px;">
                  <i class="fas fa-clipboard" style="font-size:40px;"></i>
                  <h5 class="mb-3" style="margin-top:10px;">ใบเสนอราคา</h5>
                </div>
              </div>
            </router-link>
          </div>

          <div class="col-md-3 text-center type-zoomin2">
            <a href="/draft">
              <div class="service-box mt-5 mx-auto">
                <div style="margin-top:22px;">
                  <i class="far fa-edit" style="font-size:40px;"></i>
                  <h5 class="mb-3" style="margin-top:10px;">จัดการบันทึกฉบับร่าง</h5>
                </div>
              </div>
            </a>
          </div>

          <div class="col-md-3 text-center type-zoomin4">
            <a href="/report_daily">
              <div class="service-box mt-5 mx-auto">
                <div style="margin-top:22px;">
                  <i class="fa fa-line-chart" style="font-size:40px;"></i>
                  <h5 class="mb-3" style="margin-top:10px;">รายงานยอดขายของพนักงาน</h5>
                </div>
              </div>
            </a>
          </div>
        </div>

        <!-- for  sale-admin-->
        <div class="row row-tyoe-home" v-else-if="scoped == 'sale_admin'">

          <div class="col-md-2 text-center type-zoomin1">
            <a href="/quick_quotation">
              <div class="service-box mt-5 mx-auto">
                <div style="margin-top:22px;">
                  <i class="fas fa-heartbeat" style="font-size:40px;"></i>
                  <h5 class="mb-3" style="margin-top:10px;">เช็กเบี้ยประกันภัย</h5>
                </div>
              </div>
            </a>
          </div>

          <div class="col-md-2 text-center type-zoomin1">
            <router-link to="/quotation">
              <div class="service-box mt-5 mx-auto">
                <div style="margin-top:22px;">
                  <i class="fas fa-clipboard" style="font-size:40px;"></i>
                  <h5 class="mb-3" style="margin-top:10px;">ใบเสนอราคา</h5>
                </div>
              </div>
            </router-link>
          </div>

          <div class="col-md-2 text-center type-zoomin2">
            <a href="/draft">
              <div class="service-box mt-5 mx-auto">
                <div style="margin-top:22px;">
                  <i class="far fa-edit" style="font-size:40px;"></i>
                  <h5 class="mb-3" style="margin-top:10px;">จัดการบันทึกฉบับร่าง</h5>
                </div>
              </div>
            </a>
          </div>

          <div class="col-md-2 text-center type-zoomin4">
            <a href="/report_daily">
              <div class="service-box mt-5 mx-auto">
                <div style="margin-top:22px;">
                  <i class="fa fa-line-chart" style="font-size:40px;"></i>
                  <h5 class="mb-3" style="margin-top:10px;">รายงานยอดขายของพนักงาน</h5>
                </div>
              </div>
            </a>
          </div>

          <div class="col-md-2 text-center type-zoomin5">
            <a href="/report_branch">
              <div class="service-box mt-5 mx-auto">
                <div style="margin-top:22px;">
                  <i class="fas fa-hand-holding-usd" style="font-size:40px;"></i>
                  <h5 class="mb-3" style="margin-top:10px;">รายงานยอดขายประจำสาขา</h5>
                </div>
              </div>
            </a>
          </div>

          <div class="col-md-2 text-center type-zoomin6">
            <a href="/report_district">
              <div class="service-box i-box-other mt-5 mx-auto">
                <div style="margin-top:22px;">
                  <i class="fas fa-users" style="font-size:40px;"></i>
                  <h5 class="mb-3" style="margin-top:10px;">รายงานยอดขายประจำเขต</h5>
                </div>
              </div>
            </a>
          </div>
        </div>

        <!-- for  manager_branch-->
        <div class="row row-tyoe-home" v-else-if="scoped == 'manager_branch'">
          <div class="col-md-1"></div>

          <div class="col-md-2 text-center type-zoomin1">
            <a href="/quick_quotation">
              <div class="service-box mt-5 mx-auto">
                <div style="margin-top:22px;">
                  <i class="fas fa-heartbeat" style="font-size:40px;"></i>
                  <h5 class="mb-3" style="margin-top:10px;">เช็กเบี้ยประกันภัย</h5>
                </div>
              </div>
            </a>
          </div>

          <div class="col-md-2 text-center type-zoomin1">
            <router-link to="/quotation">
              <div class="service-box mt-5 mx-auto">
                <div style="margin-top:22px;">
                  <i class="fas fa-clipboard" style="font-size:40px;"></i>
                  <h5 class="mb-3" style="margin-top:10px;">ใบเสนอราคา</h5>
                </div>
              </div>
            </router-link>
          </div>

          <div class="col-md-2 text-center type-zoomin2">
            <a href="/draft">
              <div class="service-box mt-5 mx-auto">
                <div style="margin-top:22px;">
                  <i class="far fa-edit" style="font-size:40px;"></i>
                  <h5 class="mb-3" style="margin-top:10px;">จัดการบันทึกฉบับร่าง</h5>
                </div>
              </div>
            </a>
          </div>

          <div class="col-md-2 text-center type-zoomin4">
            <a href="/report_daily">
              <div class="service-box mt-5 mx-auto">
                <div style="margin-top:22px;">
                  <i class="fa fa-line-chart" style="font-size:40px;"></i>
                  <h5 class="mb-3" style="margin-top:10px;">รายงานยอดขายของพนักงาน</h5>
                </div>
              </div>
            </a>
          </div>

          <div class="col-md-2 text-center type-zoomin5">
            <a href="/report_branch">
              <div class="service-box mt-5 mx-auto">
                <div style="margin-top:22px;">
                  <i class="fas fa-hand-holding-usd" style="font-size:40px;"></i>
                  <h5 class="mb-3" style="margin-top:10px;">รายงานยอดขายประจำสาขา</h5>
                </div>
              </div>
            </a>
          </div>

          <div class="col-md-1"></div>
        </div>

        <!-- for  manager_district-->
        <div class="row row-tyoe-home" v-else-if="scoped == 'manager_district'">
          <div class="col-md-1"></div>

          <div class="col-md-2 text-center type-zoomin1">
            <a href="/quick_quotation">
              <div class="service-box mt-5 mx-auto">
                <div style="margin-top:22px;">
                  <i class="fas fa-heartbeat" style="font-size:40px;"></i>
                  <h5 class="mb-3" style="margin-top:10px;">เช็กเบี้ยประกันภัย</h5>
                </div>
              </div>
            </a>
          </div>

          <div class="col-md-2 text-center type-zoomin1">
            <router-link to="/quotation">
              <div class="service-box mt-5 mx-auto">
                <div style="margin-top:22px;">
                  <i class="fas fa-clipboard" style="font-size:40px;"></i>
                  <h5 class="mb-3" style="margin-top:10px;">ใบเสนอราคา</h5>
                </div>
              </div>
            </router-link>
          </div>

          <div class="col-md-2 text-center type-zoomin2">
            <a href="/draft">
              <div class="service-box mt-5 mx-auto">
                <div style="margin-top:22px;">
                  <i class="far fa-edit" style="font-size:40px;"></i>
                  <h5 class="mb-3" style="margin-top:10px;">จัดการบันทึกฉบับร่าง</h5>
                </div>
              </div>
            </a>
          </div>

          <div class="col-md-2 text-center type-zoomin4">
            <a href="/report_daily">
              <div class="service-box mt-5 mx-auto">
                <div style="margin-top:22px;">
                  <i class="fa fa-line-chart" style="font-size:40px;"></i>
                  <h5 class="mb-3" style="margin-top:10px;">รายงานยอดขายของพนักงาน</h5>
                </div>
              </div>
            </a>
          </div>

          <div class="col-md-2 text-center type-zoomin6">
            <a href="/report_district">
              <div class="service-box i-box-other mt-5 mx-auto">
                <div style="margin-top:22px;">
                  <i class="fas fa-users" style="font-size:40px;"></i>
                  <h5 class="mb-3" style="margin-top:10px;">รายงานยอดขายประจำเขต</h5>
                </div>
              </div>
            </a>
          </div>

          <div class="col-md-1"></div>

        </div>
      </div>
      <!--END: Display for desktop -->

</div>
</div>
</template>

<script>
// @ is an alias to /src
import Banner from "@/components/Banner.vue";
import DatePickerTH from "@/components/Form/DatePickerTH.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "home",
  data() {
    return {
      scoped: null,
      from_component: "",
      date_select: ""
    };
  },
  mounted() {
    this.scoped =  this.checkScoped(this.$session.get("chili").scoped)
  },
  computed: {
    ...mapGetters(["checkScoped"])
  },
  components: {
    Banner,
    DatePickerTH
  },
  methods: {}
};
</script>

<style lang="scss">
</style>
